import axios from "axios";

export const dataset_info=async()=>{
    return await axios.get(`https://health.neuronai.life/dataset_info`);
}